'use client';

import { c as _c } from "react/compiler-runtime";
import { type Session } from '@shared/all/domains/sessions';
import formatRelativeTime from '@shared/utils/helpers/formatRelativeTime';
import useAuth from '@shared/utils/hooks/useAuth';
import { getBrowserIcon } from '@shared/utils/icons';
import { LogOut } from 'lucide-react';
import { useState } from 'react';
import { client, service } from '../../utils/trpc';
import Modal, { ModalHeader } from '../HOC/Modal';
import SessionLogoutConfirmation from './SessionLogoutCOnfirmation';
type Props = {
  session: Session;
  removeSession: () => void;
  isLast: boolean;
};
const SessionItem = t0 => {
  const $ = _c(35);
  const {
    session,
    removeSession,
    isLast
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      client,
      service
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    logout
  } = useAuth(t1);
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  let t2;
  if ($[1] !== logout || $[2] !== removeSession || $[3] !== session.thisDevice) {
    t2 = id => async function () {
      const [error] = await client.sessions.deleteSession.mutate({
        id
      });
      if (error) {
        return;
      }
      if (session.thisDevice) {
        logout();
      }
      removeSession();
    };
    $[1] = logout;
    $[2] = removeSession;
    $[3] = session.thisDevice;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const deleteHandler = t2;
  let t3;
  if ($[5] !== session.browserName) {
    t3 = getBrowserIcon(session.browserName);
    $[5] = session.browserName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const BrowserIcon = t3;
  let t4;
  if ($[7] !== BrowserIcon) {
    t4 = <BrowserIcon size={20} />;
    $[7] = BrowserIcon;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = session.thisDevice ? "(this device)" : "";
  let t6;
  if ($[9] !== session.browserName || $[10] !== t5) {
    t6 = <span>{session.browserName} {t5}</span>;
    $[9] = session.browserName;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <p className="flex items-center space-x-2">{t4}{t6}</p>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== session.lastUsed) {
    t8 = formatRelativeTime(new Date(session.lastUsed));
    $[15] = session.lastUsed;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <p>{t8}</p>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <div className="flex flex-col space-y-2">{t7}{t9}</div>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = "Logout out " + session.browserName + " session.";
  let t12;
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setLogoutModalOpen(true);
    t13 = <LogOut />;
    $[22] = t12;
    $[23] = t13;
  } else {
    t12 = $[22];
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t11) {
    t14 = <button title={t11} onClick={t12}>{t13}</button>;
    $[24] = t11;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== deleteHandler || $[27] !== isLast || $[28] !== logoutModalOpen || $[29] !== session.id) {
    t15 = logoutModalOpen && <Modal closeHandler={() => setLogoutModalOpen(false)}><ModalHeader closeHandler={() => setLogoutModalOpen(false)}><h2>Manage sessions</h2></ModalHeader><SessionLogoutConfirmation logoutHandler={deleteHandler(session.id)} isLast={isLast} /></Modal>;
    $[26] = deleteHandler;
    $[27] = isLast;
    $[28] = logoutModalOpen;
    $[29] = session.id;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t10 || $[32] !== t14 || $[33] !== t15) {
    t16 = <div className="mt-6 flex w-full max-w-[660px] justify-between rounded-md border border-solid border-ds-border-standard p-4 align-middle">{t10}{t14}{t15}</div>;
    $[31] = t10;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
};
export default SessionItem;